// Set NEXT_PUBLIC_DEMO_MODE=false to reconnect to the original services.
export const DEMO_MODE = process.env.NEXT_PUBLIC_DEMO_MODE !== "false";
export const demoKeywords = ["ekonomi", "pendidikan", "energi", "kendaraan listrik", "pariwisata", "teknologi", "kesehatan"];

export function demoNews(keyword = "ekonomi") {
    return Array.from({ length: 36 }, (_, i) => ({
        id: `demo-${i}`, title: `Contoh berita ${keyword}: perkembangan dan peluang ${i + 1}`,
        date: Math.floor(Date.UTC(2026, 8, 1 + i % 14) / 1000),
        sentiment: ["positive", "neutral", "negative"][i % 3],
        media: ["kompas.com", "tempo.co", "detik.com"][i % 3],
        link: `/media/${encodeURIComponent(keyword)}/detail`,
        ner: { ORG: ["Unitrend", "Pemerintah"], LOC: ["Indonesia"], MISC: [keyword, "ekonomi"] },
    }));
}

export const demoMeiliClient = {
    index: (name: string) => ({
        addDocuments: async () => ({ taskUid: 0 }),
        search: async (query: string, options: { offset?: number; limit?: number } = {}) => {
            const hits: Record<string, any>[] = name.includes("keywords") ? demoKeywords.filter(k => k.includes(query)).map(keyword => ({ keyword })) : demoNews(query);
            return { hits: hits.slice(options.offset || 0, (options.offset || 0) + (options.limit || 100)), estimatedTotalHits: hits.length };
        },
    }),
};
